import type { LegacyTrait } from '@warp-drive/core/types/schema/fields';

const VersionTraitSchema = {
  name: 'version',
  mode: 'legacy',
  fields: [
    {
      kind: 'attribute',
      name: 'itemType',
    },
    {
      kind: 'attribute',
      name: 'event',
    },
    {
      kind: 'attribute',
      name: 'objectChanges',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'changelog',
    },
    {
      kind: 'attribute',
      name: 'whodunnit',
    },
  ],
} satisfies LegacyTrait;

export default VersionTraitSchema;
